import React, { Component, createRef } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import EmptyImg from "../Dashboard/assets/img/signupDone.gif";
import logo from "../Dashboard/assets/img/logo.png";
import { Link } from "react-router-dom";
import LoginSignupMessage from "./siteComponents/LoginSignupMessage";
import ReactTelInput from "react-telephone-input";
import flags from "../Dashboard/assets/img/flags.png";
import Select from "react-select";
import { HOST_URL } from "../Dashboard/api/Api";
import GoogleLinkedinLogin from "./GoogleLinkedinLogin";
import ReCAPTCHA from 'react-google-recaptcha';
import { handleUserLog } from "../Utils/Utils";

class Signup extends Component {
    constructor(props) {
        super(props);
        this.recaptchaRef = createRef();
        this.state = {
            email: "",
            name: "",
            mobile: "",
            password: "",
            currency: "INR",
            otp: "",
            emailotp: "",
            allCountryList: [],
            method: "send",
            isChecked: false,
            IndiaUser: true,
            countryCode: "",
            loginScreen: true, // true
            otpScreen: false, // false
            isLoading: true,
            successMessage: false,
            signupDone: false,
            errorMessage: "",
            bgColor: "",
            defaultCountry: "in",
            countryCode: "91",
            showForm: false,
            ref: null,
            isVerified: false,
            step: 1,
            UtmParams: {},
            confirmPassword: "",
            passwordError: "",
            showCaptcha: false,
            emailError: '',
            page_name: '',
            ip: ""
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleInputChange = (telephone, selectedCountry) => {
        if (selectedCountry) {
            const { dialCode, iso2 } = selectedCountry;
            this.setState({
                countryCode: dialCode,
                selectedCountryCode: iso2,
            });
        }
    };

    componentDidMount() {
        this.getAllCountryList();
        this.getUserIP();

        const params = new URLSearchParams(window.location.search);
        // const queryParams = useQueryParams();
        let page_name = params.get("source");

        // source parameter exists but is empty
        if (params.has("source") && page_name === "") {
            page_name = "homepage";
        }

        console.log("Page Name:", page_name);

        const Urlparams = {};
        params.forEach((value, key) => {
            Urlparams[key] = value;
        });
        const ref = params.get("ref");


        this.setState({ ref, UtmParams: Urlparams, page_name });

        var url = document.location.href;
        var mainURL = "console.authkey.io";
        var localHost = "localhost:3000";

        if (url.indexOf(localHost) !== -1 || url.indexOf(mainURL) !== -1) {
        } else {
            window.location = "/my-account";
        }
    }

    getUserIP = () => {
        fetch("https://api.ipify.org?format=json")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ ip: data.ip });
                // console.log("User IP:", data.ip);
            })
            .catch((err) => {
                console.error("Error fetching IP:", err);
            });
    };

    getAllCountryList() {
        fetch(`${HOST_URL}/country_master.php`).then((response) => {
            response.json().then((result) => {
                // console.log(result)
                let allCountryList = [];
                if (result.success === true) {
                    for (var i = 0; i < result.data.length; i++) {
                        allCountryList.push({
                            label: result.data[i].country_name,
                            value: result.data[i].country_code,
                        });
                    }
                    this.setState({
                        allCountryList: allCountryList,
                    });
                } else {
                    this.setState({
                        successMessage: true,
                        bgColor: "alert alert-danger alert-dismissible",
                        errorMessage: result.message,
                    });
                }
            });
        });
    }

    handleChange = (selectedCountry) => {
        // console.log(selectedCountry)
        this.setState({
            countryCode: selectedCountry.value,
        });
    };

    checkBoxhandle = (e) => {
        this.setState({
            isChecked: e.target.checked, successMessage: false
        });
    };

    // validatePassword = (value) => {
    //     const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    //     if (!regex.test(value)) {
    //         this.setState({ passwordError: "Please choose a stronger password. Try a mix of letters, numbers, and symbols." });
    //         handleUserLog(this.state.email, "create Account For captcha", "Signup", "Please choose a stronger password. Try a mix of letters, numbers, and symbols.", "Signup", this.state.ip, "");
    //         return false;
    //     } else {
    //         this.setState({ passwordError: "" })
    //         return true;
    //     }
    // };

    signUpIndia() {
        document.querySelector("body").scrollTo(0, 0);
        if (
            window.location.pathname === "/signup" ||
            window.location.pathname === "/signup/"
        ) {
            this.signup(null);
        } else {
            this.signup(this.props.match.params.source);
        }
    }

    handleSubmit = (event) => {
        // const isValid = this.validatePassword(this.state.password);
        // if (!isValid) {
        //     return;
        // }

        if (this.state.password !== this.state.confirmPassword) {
            this.setState({
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: "Passwords do not match. Please make sure both fields are identical",
            });
            handleUserLog(this.state.email, "create Account For captcha", "Signup", "Passwords do not match. Please make sure both fields are identical", "Signup", this.state.ip, "");
            return;
        }

        if (!this.state.isChecked) {
            handleUserLog(this.state.email, "create Account For captcha", "Signup", "captcha Problem for signup", "Signup", this.state.ip, "");
            this.setState({
                successMessage: true,
                isLoading: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: "Please accept terms and conditions",
            });
            return;
        }

        // reCAPTCHA temporarily disabled for testing — re-enable the token check here when it comes back
        document.querySelector("body").scrollTo(0, 0);
        if (
            window.location.pathname === "/signup" ||
            window.location.pathname === "/signup/"
        ) {
            this.signup(null);
        } else {
            this.signup(this.props.match.params.source);
        }
    };

    signup(source) {
        const signup = {
            email: this.state.email,
            name: this.state.name,
            password: this.state.password,
            mobile: this.state.mobile,
            country_code: this.state.countryCode,
            currency: this.state.currency,
            method: "send",
            source: this.state.page_name,
            utm_params: this.state.UtmParams,
            page_name: this.state.page_name,
        };
        this.setState({ isLoading: false });
        fetch(`${HOST_URL}/signup_india.php`, {
            method: "post",
            headers: {
                "content-Type": "application/json",
            },
            body: JSON.stringify(signup),
        }).then((result) => {
            result.json().then((resp) => {
                //  console.log(resp);
                if (resp.success === true) {
                    this.setState({
                        loginScreen: false,
                        isLoading: true,
                        otpScreen: true,
                        successMessage: false,
                    });
                    handleUserLog(this.state.email, "user Signup", "Signup", resp.message, "Signup", this.state.ip, signup);
                } else {
                    this.setState({
                        successMessage: true,
                        isLoading: true,
                        bgColor: "alert alert-danger alert-dismissible",
                        errorMessage: resp.message,
                    });
                    handleUserLog(this.state.email, "user Signup", "Signup", resp.message, "Signup", this.state.ip, signup);
                }
            });
        });

    }

    VerifyMobile() {
        document.querySelector("body").scrollTo(0, 0);
        var url = document.location.href;
        if (
            window.location.pathname === "/signup" ||
            window.location.pathname === "/signup/"
        ) {
            const signup = {
                email: this.state.email,
                name: this.state.name,
                mobile: this.state.mobile,
                password: this.state.password,
                country_code: this.state.countryCode,
                currency: this.state.currency,
                method: "verify",
                otp: this.state.otp,
                emailotp: this.state.emailotp,
                source: this.state.page_name,
            };
            this.setState({ isLoading: false });
            fetch(`${HOST_URL}/signup_india.php`, {
                method: "post",
                headers: {
                    "content-Type": "application/json",
                },
                body: JSON.stringify(signup),
            }).then((result) => {
                result.json().then((resp) => {
                    if (resp.success === true) {
                        resp["url"] = url;
                        this.setState({
                            successMessage: false,
                            loginScreen: false,
                            otpScreen: false,
                            signupDone: true,
                            isLoading: true,
                        });
                        localStorage.setItem("login", JSON.stringify(resp));
                        localStorage.setItem("admin", JSON.stringify({ success: false }));

                        const redirectTo = this.state.ref === "/dashboard/whatsapp-widget"
                            ? "/dashboard/whatsapp-onboarding-new"
                            : `/signup-success?source=${encodeURIComponent(this.state.page_name)}`;

                        setTimeout(() => {
                            window.location = redirectTo;
                        }, 100);

                        localStorage.setItem("login", JSON.stringify(resp));
                        localStorage.setItem("admin", JSON.stringify({ success: false }));
                        setTimeout(() => {
                            window.location = `/signup-success?source=${encodeURIComponent(this.state.page_name)}`;
                        });
                        handleUserLog(this.state.email, "Verify Account", "Signup", resp.message || "signup successfull" , "Signup", this.state.ip, signup);
                    } else {
                        this.setState({ successMessage: true, isLoading: true });
                        this.setState({ bgColor: "alert alert-danger alert-dismissible" });
                        this.setState({ errorMessage: resp.message });
                        handleUserLog(this.state.email, "Verify Account", "Signup", resp.message || "signup successfull" , "Signup", this.state.ip, signup);
                    }
                });
            });
        } else {
            var url = document.location.href;
            const signup = {
                email: this.state.email,
                name: this.state.name,
                mobile: this.state.mobile,
                password: this.state.password,
                country_code: this.state.countryCode,
                currency: this.state.currency,
                method: "verify",
                otp: this.state.otp,
                emailotp: this.state.emailotp,
                source: this.state.page_name,
            };
            this.setState({ isLoading: false });
            fetch(`${HOST_URL}/signup_india.php`, {
                method: "post",
                headers: {
                    "content-Type": "application/json",
                },
                body: JSON.stringify(signup),
            }).then((result) => {
                result.json().then((resp) => {
                    if (resp.success === true) {
                        resp["url"] = url;
                        this.setState({
                            successMessage: false,
                            loginScreen: false,
                            otpScreen: false,
                            signupDone: true,
                            isLoading: true,
                        });
                        localStorage.setItem("login", JSON.stringify(resp));
                        localStorage.setItem("admin", JSON.stringify({ success: false }));
                        setTimeout(() => {
                            window.location = `/signup-success?source=${encodeURIComponent(this.state.page_name)}`;
                        });
                    } else {
                        this.setState({ successMessage: true, isLoading: true });
                        this.setState({ bgColor: "alert alert-danger alert-dismissible" });
                        this.setState({ errorMessage: resp.message });
                    }
                });
            });
        }
    }

    handleCreateAccountClick = (event) => {
        event.preventDefault();
        this.setState({ showForm: true }); // Reveal the form when button is clicked
    };
    responseFacebook = (response) => {
        var url = document.location.href;
        const loginWithFacebook = {
            email: response.email,
            name: response.name,
            api_response: response,
        };
        fetch(`${HOST_URL}/facebook_login.php`, {
            method: "post",
            headers: {
                "content-Type": "application/json",
            },
            body: JSON.stringify(loginWithFacebook),
        }).then((result) => {
            result.json().then((resp) => {
                if (resp.success === true && resp.account === "old") {
                    this.setState({
                        show: true,
                        bgColor: "alert alert-success alert-dismissible",
                        loginMessage: "success",
                    });
                    resp["url"] = url;
                    localStorage.setItem("login", JSON.stringify(resp));
                    localStorage.setItem("admin", JSON.stringify({ success: false }));
                    setTimeout(() => {
                        window.location = "/dashboard";
                    });
                } else if (resp.success === true && resp.account === "new") {
                    resp["url"] = url;
                    this.setState({
                        show: true,
                        bgColor: "alert alert-success alert-dismissible",
                        loginMessage: "success",
                    });
                    localStorage.setItem("login", JSON.stringify(resp));
                    localStorage.setItem("admin", JSON.stringify({ success: false }));
                    setTimeout(() => {
                        window.location = `/signup-success?source=${encodeURIComponent(this.state.page_name)}`;
                    });
                } else {
                    this.setState({
                        show: true,
                        bgColor: "alert alert-danger alert-dismissible",
                        loginMessage: resp.message,
                    });
                }
            });
        });
    };

    render() {
        const { selectedCountry } = this.state;
        const { showForm } = this.state;

        return (
            <div style={{ overflow: "auto" }}>
                <Helmet>
                    <title>
                        Signup | Authkey
                    </title>
                    <meta
                        name="description"
                        content="Signup on Authkey. Access SMS, Voice,WhatsApp, RCS, True Caller messages and Email APIs. Start your seamless communication journey today!"
                    />
                    <link rel="canonical" href="https://console.authkey.io/signup" />
                    <style type="text/css">{`
                    @media only screen and (max-width: 600px) {
                        .mobile-img {
                        display: none;
                        }
            }
        `}</style>
                </Helmet>

                <section>
                    <div className=" container-fluid d-flex flex-column">
                        <div className="row justify-content-center heightVh min-vh-100">
                            <LoginSignupMessage />
                            <div className="col-lg-6">
                                <div className="login-new-box sm-p-0">

                                    {this.state.loginScreen ? (
                                        <form className="form-row col-md-6 col-lg-10 pl-md-5 pr-sm-0">
                                            {/* <FacebookLogin
                            appId="4884679621657801"
                            textButton="Signup With Facebook"
                            autoLoad={false}
                            fields="name,email"
                            callback={this.responseFacebook}
                          />

                          <div className="form-group col-md-12 mt-4">
                            <hr className="mt-0 mb-0" />{" "}
                            <span className="or-center">
                              or use Email address & password
                            </span>
                          </div> */}

                                            <div className="mb-0 col-md-12 text-left login-box">
                                                <Link to="/">
                                                    <img
                                                        className="img-fluid mb-4"
                                                        src={logo}
                                                        style={{ maxHeight: "32px", objectFit: "contain" }}
                                                    />

                                                </Link>
                                                <h3 className="text-center  mt-2 mb-4">Create a free account now </h3>
                                            </div>

                                            <div className="col-md-12 d-flex justify-content-center mb-2">
                                                <div
                                                    className="d-flex align-items-center justify-content-center"
                                                    style={{ width: "100%", maxWidth: "300px" }}
                                                >
                                                    <GoogleLinkedinLogin redirectPath={this.state.ref || `/signup-success?source=${encodeURIComponent(this.state.page_name)}`} context="signup" page_name={this.state.page_name} />
                                                </div>
                                            </div>


                                            <div className="col-md-12 my-2">
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <hr className="flex-grow-1 border-secondary" />
                                                    <span className="mx-3 text-muted fw-semibold">OR</span>
                                                    <hr className="flex-grow-1 border-secondary" />
                                                </div>
                                            </div>

                                            {!this.state.showForm && (
                                                <div className="col-md-12 d-flex justify-content-center mb-4">
                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{ width: "100%", maxWidth: "270px" }}
                                                    >
                                                        <button
                                                            className="btn btn-success w-100 py-2"
                                                            onClick={this.handleCreateAccountClick}
                                                            style={{
                                                                fontSize: "16px",
                                                                borderRadius: "8px",
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            Create Account
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {this.state.showForm && (
                                                <>
                                                    <div className="form-group col-md-6 ">
                                                        <label className="form-control-label">Name</label>
                                                        <input
                                                            type="text"
                                                            value={this.state.name}
                                                            onChange={(event) => {
                                                                const value = event.target.value;
                                                                const regex = /^[A-Za-z]+$/; // Only letters

                                                                if (value === "" || regex.test(value)) {
                                                                    this.setState({ name: value });
                                                                }
                                                            }}
                                                            className="form-control logininput"
                                                            placeholder="Enter Name"
                                                        />
                                                    </div>


                                                    <div className="form-group col-md-6 ">
                                                        <label className="form-control-label">Email</label>
                                                        <div className="input-group">
                                                            <input
                                                                type="email"
                                                                onChange={(event) => {
                                                                    const value = event.target.value;
                                                                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                                                                    if (emailRegex.test(value)) {
                                                                        this.setState({ email: value, emailError: '' });
                                                                    } else {
                                                                        this.setState({ email: value, emailError: 'Invalid email format' });
                                                                    }
                                                                }}
                                                                className="form-control logininput"
                                                                placeholder="Enter Email"
                                                            />

                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 ">
                                                        <label className="form-control-label">
                                                            Select Your Country{" "}
                                                        </label>

                                                        <div className="form-row">
                                                            <div className="input-group col-md-12 mb-1">
                                                                <Select
                                                                    value={selectedCountry}
                                                                    onChange={this.handleChange}
                                                                    options={this.state.allCountryList}
                                                                    placeholder={"Enter Your Country Name"}
                                                                    closeMenuOnSelect={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-group col-md-12">
                                                        <label className="form-control-label">Mobile</label>
                                                        <div className="input-group">
                                                            <div className="input-group-prepend ReactTelFullbox">
                                                                <ReactTelInput
                                                                    defaultCountry={this.state.defaultCountry}
                                                                    flagsImagePath={flags}
                                                                    onChange={this.handleInputChange}
                                                                />
                                                            </div>
                                                            <input
                                                                type="number"
                                                                className="form-control logininput"
                                                                placeholder="Enter Mobile Number"
                                                                onChange={(event) => {
                                                                    this.setState({ mobile: event.target.value });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-group col-md-12 ">
                                                        <label className="form-control-label">Password</label>
                                                        <div className="input-group">
                                                            <input
                                                                type="password"
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        password: event.target.value, successMessage: false, passwordError: ""
                                                                    });
                                                                }}
                                                                className="form-control logininput"
                                                                placeholder="Enter Strong Password"
                                                                style={this.state.passwordError ? { borderColor: 'red' } : {}}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group col-md-12 ">
                                                        <label className="form-control-label">Confirm Password</label>
                                                        <div className="input-group">
                                                            <input
                                                                type="password"
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        confirmPassword: event.target.value, successMessage: false
                                                                    });
                                                                }}
                                                                className="form-control logininput"
                                                                placeholder="Confirm Password"
                                                                style={this.state.passwordError ? { borderColor: 'red' } : {}}
                                                            />
                                                        </div>
                                                    </div>
                                                    {this.state.passwordError && <div style={{ color: 'red', marginBottom: '10px', fontSize: "12px" }}>{this.state.passwordError}</div>}
                                                    {!this.state.passwordError && <div style={{ color: 'blue', marginBottom: '10px', fontSize: "12px" }}>Please choose a stronger password. Try a mix of letters, numbers, and symbols.</div>}
                                                    {this.state.emailError && (
                                                        <small className="text-danger">{this.state.emailError}</small>
                                                    )}
                                                    <div className="form-group col-md-12">
                                                        {this.state.successMessage ? (
                                                            <div className={this.state.bgColor} role="alert">
                                                                <button
                                                                    type="button"
                                                                    className="close"
                                                                    data-dismiss="alert"
                                                                    aria-label="Close"
                                                                >
                                                                    <span aria-hidden="true">×</span>
                                                                </button>
                                                                <div className="">{this.state.errorMessage}</div>
                                                            </div>
                                                        ) : null}
                                                    </div>

                                                    {/* {this.state.showCaptcha &&
                                                        <>
                                                            <ReCAPTCHA
                                                                sitekey="6Le6d5wrAAAAACOgGFvxkOYNxYi1diCEFrpjM5zt"
                                                                ref={this.recaptchaRef}
                                                            />

                                                        </>
                                                    } */}
                                                    <div className="col-md-12">
                                                        <div className="ml-4">
                                                            <input
                                                                type="checkbox"
                                                                onChange={this.checkBoxhandle}
                                                                value={this.state.isChecked}
                                                                className="form-check-input mr-2"
                                                                id="fallback"
                                                            />{" "}
                                                            <small
                                                                style={{ display: "block", lineHeight: "20px" }}
                                                                className="pl-2"
                                                            >
                                                                By submitting this form, you agree to the{" "}
                                                                <a href="https://authkey.io/term-and-condition">
                                                                    Terms of Use
                                                                </a>{" "}
                                                                and have read the{" "}
                                                                <a href="https://authkey.io/privacy-policy">
                                                                    Privacy Policy
                                                                </a>
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <div className="mt-2 col-md-12  m-auto">
                                                        {this.state.isLoading ? (
                                                            // this.state.showCaptcha ?
                                                            //     <button
                                                            //         type="button"
                                                            //         onClick={this.handleSubmit}
                                                            //         className="btn w-100 btn-block btn-sm btn-primary"
                                                            //     >
                                                            //         {" "}
                                                            //         Submit{" "}
                                                            //         <FontAwesomeIcon icon={faArrowRight} />{" "}
                                                            //     </button>
                                                            //     :
                                                                <button
                                                                    type="button"
                                                                    onClick={() => this.handleSubmit()}
                                                                    className="btn w-100 btn-block btn-sm btn-primary"
                                                                >
                                                                    {" "}
                                                                    create an account{" "}
                                                                    <FontAwesomeIcon icon={faArrowRight} />{" "}
                                                                </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-block btn-sm btn-primary"
                                                            >
                                                                <span className="spinner-border text-white spinner-border-sm"></span>{" "}
                                                                Please Wait..
                                                            </button>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            <div className="form-group text-center col-md-12 mb-2">
                                                <p className="mt-2" style={{ fontSize: "14px", color: "#6c757d" }}>
                                                    Already have an account?{" "}
                                                    <Link to={`/login?ref=${this.state.ref || ""}`} style={{ fontWeight: "600", color: "#007bff" }}>
                                                        Sign in
                                                    </Link>
                                                </p>
                                            </div>

                                            <div className="mt-2 text-center" style={{ width: "100%" }}>
                                                <small style={{ fontSize: "9px", color: "#6c757d" }}>
                                                    © 2020-2024 AuthKey.io is a product of Datagen Internet Services Pvt. Ltd. | All rights reserved
                                                </small>
                                            </div>
                                        </form>
                                        // <form className="form-row col-md-6 col-lg-10 pl-md-5 pr-sm-0 mt-4">
                                        //   <div className="form-group col-md-12">
                                        //     {this.state.successMessage ? (
                                        //       <div className={this.state.bgColor} role="alert">
                                        //         <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        //           <span aria-hidden="true">×</span>
                                        //         </button>
                                        //         <div>{this.state.errorMessage}</div>
                                        //       </div>
                                        //     ) : null}
                                        //   </div>

                                        //   {/* Logo */}
                                        //   <div className="mb-0 col-md-12 text-left login-box">
                                        //     <Link to="/">
                                        //       <img className="img-fluid mb-5" src={logo} style={{ maxHeight: "32px", objectFit: "contain" }} />
                                        //     </Link>
                                        //   </div>

                                        //   {/* Google Login */}
                                        //   <div className="col-md-12">
                                        //     <GoogleOAuthProvider clientId="YOUR_GOOGLE_CLIENT_ID">
                                        //       <GoogleLogin onSuccess={this.handleGoogleLogin} text="continue_with" />
                                        //     </GoogleOAuthProvider>
                                        //   </div>

                                        //   {/* LinkedIn Login */}
                                        //   <div className="col-md-12 mt-4">
                                        //     <button
                                        //       className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center position-relative"
                                        //       onClick={this.handleLinkedInLogin}
                                        //       style={{
                                        //         fontSize: "14px",
                                        //         height: "40px",
                                        //         fontFamily: "'Google Sans', sans-serif",
                                        //         paddingLeft: "40px", // Adjust spacing as needed
                                        //       }}
                                        //       aria-label="Continue with LinkedIn"
                                        //     >
                                        //       <FaLinkedin
                                        //         style={{
                                        //           position: "absolute",
                                        //           left: "12px", // Adjust spacing as needed
                                        //           fontSize: "22px",
                                        //         }}
                                        //       />
                                        //       <span>Continue with LinkedIn</span>
                                        //     </button>
                                        //   </div>

                                        //   {/* Separator */}
                                        //   <div className="col-md-12">
                                        //     <div className="d-flex align-items-center my-4">
                                        //       <hr className="flex-grow-1 border-secondary" />
                                        //       <span className="mx-3 text-muted fw-semibold">OR</span>
                                        //       <hr className="flex-grow-1 border-secondary" />
                                        //     </div>
                                        //   </div>

                                        //   {/* Create Account Button */}
                                        //   <div className="row">
                                        //     <div className="col-md-6 mx-auto">
                                        //       <button className="btn btn-success w-100" onClick={this.handleCreateAccountClick}>
                                        //         Create Account
                                        //       </button>
                                        //     </div>
                                        //   </div>

                                        //   {/* Show Account Creation Form After Button Click */}
                                        //   {this.state.showForm && (
                                        //     <>
                                        //       <div className="mb-0 col-md-12 text-left login-box">
                                        //         <h3>Create a free account now</h3>
                                        //       </div>

                                        //       {/* Name Input */}
                                        //       <div className="form-group col-md-6">
                                        //         <label className="form-control-label">Name</label>
                                        //         <div className="input-group">
                                        //           <input
                                        //             type="text"
                                        //             onChange={(event) => this.setState({ name: event.target.value })}
                                        //             className="form-control logininput"
                                        //             placeholder="Enter Name"
                                        //           />
                                        //         </div>
                                        //       </div>

                                        //       {/* Email Input */}
                                        //       <div className="form-group col-md-6">
                                        //         <label className="form-control-label">Email</label>
                                        //         <div className="input-group">
                                        //           <input
                                        //             type="email"
                                        //             onChange={(event) => this.setState({ email: event.target.value })}
                                        //             className="form-control logininput"
                                        //             placeholder="Enter Email"
                                        //           />
                                        //         </div>
                                        //       </div>

                                        //       {/* Country Select */}
                                        //       <div className="col-md-12">
                                        //         <label className="form-control-label">Select Your Country</label>
                                        //         <div className="form-row">
                                        //           <div className="input-group col-md-12 mb-1">
                                        //             <Select
                                        //               value={selectedCountry}
                                        //               onChange={this.handleChange}
                                        //               options={this.state.allCountryList}
                                        //               placeholder="Enter Your Country Name"
                                        //               closeMenuOnSelect={true}
                                        //             />
                                        //           </div>
                                        //         </div>
                                        //       </div>

                                        //       {/* Mobile Input */}
                                        //       <div className="form-group col-md-12">
                                        //         <label className="form-control-label">Mobile</label>
                                        //         <div className="input-group">
                                        //           <div className="input-group-prepend ReactTelFullbox">
                                        //             <ReactTelInput
                                        //               defaultCountry={this.state.defaultCountry}
                                        //               flagsImagePath={flags}
                                        //               onChange={this.handleInputChange}
                                        //             />
                                        //           </div>
                                        //           <input
                                        //             type="text"
                                        //             className="form-control logininput"
                                        //             placeholder="Enter Mobile Number"
                                        //             onChange={(event) => this.setState({ mobile: event.target.value })}
                                        //           />
                                        //         </div>
                                        //       </div>

                                        //       {/* Password Input */}
                                        //       <div className="form-group col-md-12">
                                        //         <label className="form-control-label">Password</label>
                                        //         <div className="input-group">
                                        //           <input
                                        //             type="password"
                                        //             onChange={(event) => this.setState({ password: event.target.value })}
                                        //             className="form-control logininput"
                                        //             placeholder="Enter Strong Password"
                                        //           />
                                        //         </div>
                                        //       </div>

                                        //       {/* Terms and Conditions */}
                                        //       <div className="col-md-12">
                                        //         <div className="ml-4">
                                        //           <input
                                        //             type="checkbox"
                                        //             onChange={this.checkBoxhandle}
                                        //             value={this.state.isChecked}
                                        //             className="form-check-input mr-2"
                                        //             id="fallback"
                                        //           />
                                        //           <small style={{ display: "block", lineHeight: "20px" }} className="mb-2 pl-2">
                                        //             By submitting this form, you agree to the{" "}
                                        //             <a href="https://authkey.io/term-and-condition">Terms of Use</a> and have read the{" "}
                                        //             <a href="https://authkey.io/privacy-policy">Privacy Policy</a>
                                        //           </small>
                                        //         </div>
                                        //       </div>

                                        //       {/* Submit Button */}
                                        //       <div className="mt-4 col-md-12 m-auto">
                                        //         {this.state.isLoading ? (
                                        //           <button type="button" onClick={() => this.signUpIndia()} className="btn w-100 btn-block btn-sm btn-primary">
                                        //             Create an account <FontAwesomeIcon icon={faArrowRight} />
                                        //           </button>
                                        //         ) : (
                                        //           <button type="button" className="btn btn-block btn-sm btn-primary">
                                        //             <span className="spinner-border text-white spinner-border-sm"></span> Please Wait..
                                        //           </button>
                                        //         )}
                                        //       </div>

                                        //       {/* Sign In Link */}
                                        //       <div className="form-group text-center col-md-12">
                                        //         <div className="mt-2">
                                        //           <p>
                                        //             Already Have Account? <Link to={`/login?ref=${this.state.ref || ""}`}>Sign in</Link>
                                        //           </p>
                                        //         </div>
                                        //       </div>
                                        //     </>
                                        //   )}

                                        //   {/* Footer */}
                                        //   <div style={{ textAlign: "center", width: "100%" }}>
                                        //     <small style={{ fontSize: "11px" }}>
                                        //       © 2020-2024 AuthKey.io Datagen Internet Services Pvt. Ltd. | All rights reserved
                                        //     </small>
                                        //   </div>
                                        // </form>


                                    ) : null}

                                    {this.state.otpScreen ? (
                                        <>
                                            <form
                                                className="form-row col-md-8  pr-5"
                                                id="otp-verify-form"
                                            >
                                                <div className="mb-3 text-left col-md-12 login-box">
                                                    <h5 className="alert  alert-success">
                                                        We have sent 6 digit OTP on your{" "}
                                                        {this.state.countryCode === "91"
                                                            ? "Mobile & Email"
                                                            : "Email"}{" "}
                                                    </h5>
                                                </div>
                                                <span className="clearfix"></span>

                                                {this.state.countryCode === "91" ? (
                                                    <div className="form-group col-md-12">
                                                        <div className="">
                                                            <label className="form-control-label">
                                                                Enter Mobile OTP
                                                            </label>
                                                            <input
                                                                type="email"
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        otp: event.target.value,
                                                                    });
                                                                }}
                                                                className="form-control logininput"
                                                                placeholder="Enter 6 Digit Mobile OTP"
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                                <div className="form-group col-md-12">
                                                    <label className="form-control-label">
                                                        Enter Email OTP
                                                    </label>
                                                    <div className="">
                                                        <input
                                                            type="email"
                                                            onChange={(event) => {
                                                                this.setState({
                                                                    emailotp: event.target.value,
                                                                });
                                                            }}
                                                            className="form-control logininput"
                                                            placeholder="Enter 6 Email OTP"
                                                        />
                                                    </div>
                                                </div>

                                                {this.state.isLoading ? (
                                                    <div className="mt-4 col-md-12">
                                                        <button
                                                            type="button"
                                                            onClick={() => this.VerifyMobile()}
                                                            className="btn w-100 btn-block btn-sm btn-primary"
                                                        >
                                                            Verify Account{" "}
                                                            <FontAwesomeIcon icon={faArrowRight} />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn w-100 btn-block btn-sm btn-primary"
                                                    >
                                                        <span className="spinner-border text-white spinner-border-sm"></span>{" "}
                                                        Please Wait..
                                                    </button>
                                                )}
                                            </form>
                                        </>
                                    ) : null}

                                    {this.state.signupDone ? (
                                        <div className="text-center pr-5">
                                            <div className="card-body">
                                                <img
                                                    alt="Empty Data"
                                                    style={{ width: "100px" }}
                                                    src={EmptyImg}
                                                />
                                                <p>
                                                    Your account has been created successfully, <br />{" "}
                                                    Please find login credentials on your email.
                                                </p>
                                                <Link className="btn btn-primary btn-sm" to="login">
                                                    Login To Account
                                                </Link>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Signup;
